// extracted by mini-css-extract-plugin
export var AboutContainer = "about-module--AboutContainer--NhU3e";
export var AboutSection = "about-module--AboutSection--10kD9";
export var InnerContainer = "about-module--InnerContainer--3e45X";
export var Text = "about-module--Text--39Xkq";